<template>
  <div class="bg-white">
    <div>
      <Donbanner />
      <div class="">
        <div>
          <Healthcare />
        </div>
        <div class=""><Tree /></div>
        <div class="lg:px-20 md:px-20 px-4 py-20 bg-white">
          <Gratitude />
        </div>
        <!-- bg-caregiverimg -->

        <div class="lg:pt-20 md:pt-12 bg-white">
          <!-- <Help /> -->
          <Dona />

          <div class="lg:px-20 md:px-8 px-4"><How /></div>
        </div>
      </div>
      <div class="lg:px-20 md:px-20 px-4 bg-white"><Ssd /></div>
      <!-- <Dona /> -->
      <Egs />
    </div>

    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import Donbanner from "@/views/donation/components/Donbanner.vue";
import Healthcare from "@/views/donation/components/Healthcare.vue";
// import Help from "@/views/donation/components/Help.vue";
import Dona from "@/views/donation/components/Dona.vue";
import Egs from "@/views/donation/components/Egs.vue";
import How from "@/views/donation/components/How.vue";
import Ssd from "@/views/donation/components/Ssd.vue";
import DownloadApp from "@/views/home/components/DownloadApp.vue";
import Footer from "../Footer.vue";
import Gratitude from "./components/Gratitude.vue";
import Tree from "./components/Tree.vue";

export default {
  components: {
    Donbanner,
    Healthcare,
    // Help,
    Dona,
    Egs,
    How,
    Ssd,
    DownloadApp,
    Footer,
    Gratitude,
    Tree,
  },
};
</script>
